/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  Suspense, lazy, ComponentType,
} from 'react';

const withGilroySuspense = (LazyComponent: React.LazyExoticComponent<ComponentType<any>>) => {
  const Wrapped = function WrappedGilroy(props: Record<string, unknown>) {
    return (
      <Suspense fallback={null}>
        <LazyComponent {...props} />
      </Suspense>
    );
  };
  return Wrapped;
};

const GilroyLazy = lazy(() => import('gilroy-global').then((m) => ({ default: m.Gilroy })));
const StatesAndActionsWrapperLazy = lazy(() => import('gilroy-global').then((m) => ({ default: m.StatesAndActionsWrapper })));
const CustomTabGilroyLazy = lazy(() => import('gilroy-global').then((m) => ({ default: m.CustomTabGilroy })));
const ChatbotV2FullSkeletonLazy = lazy(() => import('gilroy-global').then((m) => ({ default: m.ChatbotV2FullSkeleton })));

export const Gilroy = withGilroySuspense(GilroyLazy);
export const StatesAndActionsWrapper = withGilroySuspense(StatesAndActionsWrapperLazy);
export const CustomTabGilroy = withGilroySuspense(CustomTabGilroyLazy);
export const ChatbotV2FullSkeleton = withGilroySuspense(ChatbotV2FullSkeletonLazy);

export const loadGilroyActions = () => import('gilroy-global').then((m) => m.actions);
